import { createSlice } from "@reduxjs/toolkit";
import { memberCategoryApi } from "../api/memberCategoryApi";

const initialState = {
    memberCategories: [],
    selectedMemberCategory: null,
    loading: false,
    error: null
};

const memberCategorySlice = createSlice({
    name: "memberCategory",
    initialState,
    reducers: {
        setSelectedMemberCategory: (state, action) => {
            state.selectedMemberCategory = action.payload;
        },
        clearSelectedMemberCategory: (state) => {
            state.selectedMemberCategory = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Handle get member categories
            .addMatcher(memberCategoryApi.endpoints.getMemberCategories.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(memberCategoryApi.endpoints.getMemberCategories.matchFulfilled, (state, action) => {
                state.loading = false;
                state.memberCategories = action.payload;
            })
            .addMatcher(memberCategoryApi.endpoints.getMemberCategories.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle get member category by ID
            .addMatcher(memberCategoryApi.endpoints.getMemberCategoryById.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(memberCategoryApi.endpoints.getMemberCategoryById.matchFulfilled, (state, action) => {
                state.loading = false;
                state.selectedMemberCategory = action.payload;
            })
            .addMatcher(memberCategoryApi.endpoints.getMemberCategoryById.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle create member category
            .addMatcher(memberCategoryApi.endpoints.createMemberCategory.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(memberCategoryApi.endpoints.createMemberCategory.matchFulfilled, (state, action) => {
                state.loading = false;
                if (!state.memberCategories) {
                    state.memberCategories = [];
                }
                state.memberCategories.push(action.payload);
            })
            .addMatcher(memberCategoryApi.endpoints.createMemberCategory.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle update member category
            .addMatcher(memberCategoryApi.endpoints.updateMemberCategory.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(memberCategoryApi.endpoints.updateMemberCategory.matchFulfilled, (state, action) => {
                state.loading = false;
                state.selectedMemberCategory = action.payload;
                const index = state.memberCategories.findIndex(cat => cat.id === action.payload.id);
                if (index !== -1) {
                    state.memberCategories[index] = action.payload;
                }
            })
            .addMatcher(memberCategoryApi.endpoints.updateMemberCategory.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // Handle delete member category
            .addMatcher(memberCategoryApi.endpoints.deleteMemberCategory.matchPending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addMatcher(memberCategoryApi.endpoints.deleteMemberCategory.matchFulfilled, (state, action) => {
                state.loading = false;
                state.memberCategories = state.memberCategories.filter(cat => cat.id !== action.meta.arg);
                if (state.selectedMemberCategory?.id === action.meta.arg) {
                    state.selectedMemberCategory = null;
                }
            })
            .addMatcher(memberCategoryApi.endpoints.deleteMemberCategory.matchRejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
});

export const { setSelectedMemberCategory, clearSelectedMemberCategory } = memberCategorySlice.actions;
export default memberCategorySlice.reducer;